import { render, staticRenderFns } from "./BravoAppDesk.vue?vue&type=template&id=1f6270d2&scoped=true&"
import script from "./BravoAppDesk.vue?vue&type=script&lang=js&"
export * from "./BravoAppDesk.vue?vue&type=script&lang=js&"
import style0 from "./BravoAppDesk.vue?vue&type=style&index=0&id=1f6270d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6270d2",
  null
  
)

export default component.exports